// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.small {
  padding-left: 18px;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/post-editor/tag-selector/tag-selector.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF","sourcesContent":[".small{\n  padding-left: 18px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
